import styled from "styled-components";

export const Title = styled("h3")`
  margin: 0px;
  font-weight: 600;
  font-size: 22px;
  line-height: 26px;
  margin: 0;
`;

export const Card = styled('div') <{ background }>`
  position: relative;
  overflow: hidden;
  padding: 40px 0px;
  background: ${({ background }) => background};
  background-size: 200%;
  
`

export const Flex = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  
  @media(min-width: 768px){
    justify-content: flex-end;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: 28px;
  right: 22px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0px;

  @media (max-width: 768px) {
    top: 9px;
    right: 10px;
  }
`;